import { render, staticRenderFns } from "./UserNavigationIcon.vue?vue&type=template&id=25b43576&scoped=true&"
import script from "./UserNavigationIcon.vue?vue&type=script&lang=js&"
export * from "./UserNavigationIcon.vue?vue&type=script&lang=js&"
import style0 from "./UserNavigationIcon.vue?vue&type=style&index=0&id=25b43576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b43576",
  null
  
)

export default component.exports